import axios from 'axios';

const updateOwner = params => axios.put(`owner`, params);

export { updateOwner };
